/** Fixed values for the whole portal. Environment-specific values live in src/config. */

/** Sent on every API call: the API requires it for cookie-signed changes (CSRF protection, API.md §2). */
export const REQUESTED_WITH = { header: "X-Requested-With", value: "brocoly-admin-web" } as const;

/** Display preference only (not user data, so it may live in localStorage). index.html reads the same key. */
export const THEME_STORAGE_KEY = "brocoly.theme";

/** Whether the desktop sidebar is collapsed to icons (a display preference, kept in this browser). */
export const SIDEBAR_STORAGE_KEY = "brocoly.sidebar";

/** Who may use this portal (the API checks it again on every admin call). */
export const ADMIN_ROLES = ["ADMIN", "SUPER_ADMIN"] as const;

/** Server data in memory only (TanStack Query): fresh for 30 s, dropped 5 min after the last screen using it. */
export const QUERY_DEFAULTS = {
  staleTimeMs: 30_000,
  gcTimeMs: 5 * 60_000,
  /** Retries for reads that failed on the network or a 5xx (never 4xx: retrying can't fix those). */
  maxRetries: 2,
} as const;

/** Money is shown for India: ₹ and Indian digit grouping. */
export const LOCALE = "en-IN";
export const CURRENCY = "INR";

/** The API's reporting time zone (REPORTING_TIMEZONE, default IST): months and days in reports are in it. */
export const REPORTING_TIMEZONE = "Asia/Kolkata";
